export default __webpack_public_path__ + "91af8751ae6f1600658e4a683fc3dba0.svg";